<template>
  <div v-if="$store.state.user.access_nivel != 1">
    <div class="row justify-content-md-center" style="font-size: 6px">
      <div class="col-lg col-md-6">
        <div class="card">
          <div class="card-header-patio">
            <div class="card-title">No Pátio</div>
          </div>
          <div class="card-body">
            <div v-if="count.loaded">
              <div class="card-value">{{ availableVehicles.length }}</div>
            </div>
            <div v-else>
              <div class="fa-3x text-center">
                <i class="fas fa-circle-notch fa-spin"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg col-md-6">
        <div class="card">
          <div class="card-header-reservados">
            <div class="card-title">Reservados</div>
          </div>
          <div class="card-body">
            <div v-if="count.loaded">
              <div class="card-value">{{ reservedVehicles.length }}</div>
            </div>
            <div v-else>
              <div class="fa-3x text-center">
                <i class="fas fa-circle-notch fa-spin"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg col-md-6">
        <div class="card">
          <div class="card-header-retirados">
            <div class="card-title">Retirados</div>
          </div>
          <div class="card-body">
            <div v-if="count.loaded">
              <div class="card-value">{{ retreatVehicles.length }}</div>
            </div>
            <div v-else>
              <div class="fa-3x text-center">
                <i class="fas fa-circle-notch fa-spin"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg col-md-6">
        <div class="card">
          <div class="card-header-atrasados">
            <div class="card-title">Atrasados</div>
          </div>
          <div class="card-body">
            <div v-if="count.loaded">
              <div class="card-value">{{ lateVehicles.length }}</div>
            </div>
            <div v-else>
              <div class="fa-3x text-center">
                <i class="fas fa-circle-notch fa-spin"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg col-md-6">
        <div class="card">
          <div class="card-header-devolvidos">
            <div class="card-title">Devolvidos</div>
          </div>
          <div class="card-body">
            <div v-if="count.loaded">
              <div class="card-value">{{ devolvedVehicles.length }}</div>
            </div>
            <div v-else>
              <div class="fa-3x text-center">
                <i class="fas fa-circle-notch fa-spin"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg col-md-6">
        <div class="card">
          <div class="card-header-preReserva">
            <div class="card-title">Pré-reservas</div>
          </div>
          <div class="card-body">
            <div v-if="count.loaded">
              <div class="card-value">{{ preReserveVehicles.length }}</div>
            </div>
            <div v-else>
              <div class="fa-3x text-center">
                <i class="fas fa-circle-notch fa-spin"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <div class="card-title">
              Painel de Veículos
              <a
                data-toggle="collapse"
                href="#"
                @click="filter()"
                class="btn-filter"
              >
                Atualizar
                <i class="fas fa-sync-alt"></i>
              </a>

              <a
                data-toggle="collapse"
                href="#filterCars"
                aria-expanded="false"
                aria-controls="filterCars"
                class="btn-filter"
                style="padding-right: 25px"
              >
                Filtros
                <i class="fas fa-filter"></i>
              </a>

              <span class="span-filter" style="padding-left: 30%"></span>
            </div>
          </div>
          <div class="card-body car-filters">
            <div class="collapse" id="filterCars" style="display: contents;">
              <div class="row mb-3">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="branch">
                      <span class="required">*</span> Filial*
                    </label>
                    <v-select
                      :options="branches"
                      label="description"
                      :clearable="false"
                      :reduce="(branches) => branches.id"
                      class="style-chooser-home"
                      v-model="home.branch_id"
                     
                    >
                      <template slot="no-options"
                        >Digite para pesquisar Filiais</template
                      >
                    </v-select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <button type="button" @click="filter" class="btn btn-add">
                    Filtrar
                  </button>
                </div>
              </div>
            </div>
            <div class="filter-control">
              <ul class="car-filter controls">
                <li
                  class="control"
                  data-mixitup-control
                  data-filter="all"
                  :class="{ 'mixitup-control-active': selectedMenu == 'todos' }"
                  @click="selectedMenu = 'todos'"
                >
                  Todos ({{ allVehicles.length }})
                </li>
                <li
                  class="control"
                  data-mixitup-control
                  data-filter=".patio"
                  :class="{ 'mixitup-control-active': selectedMenu == 'patio' }"
                  @click="selectedMenu = 'patio'"
                >
                  No Pátio ({{ availableVehicles.length }})
                </li>
                <li
                  class="control"
                  data-mixitup-control
                  data-filter=".reservado"
                  :class="{
                    'mixitup-control-active': selectedMenu == 'reservado',
                  }"
                  @click="selectedMenu = 'reservado'"
                >
                  Reservados ({{ reservedVehicles.length }})
                </li>
                <li
                  class="control"
                  data-mixitup-control
                  data-filter=".retirado"
                  :class="{
                    'mixitup-control-active': selectedMenu == 'retirado',
                  }"
                  @click="selectedMenu = 'retirado'"
                >
                  Retirados ({{ retreatVehicles.length }})
                </li>
                <li
                  class="control"
                  data-mixitup-control
                  data-filter=".atrasado"
                  :class="{
                    'mixitup-control-active': selectedMenu == 'atrasado',
                  }"
                  @click="selectedMenu = 'atrasado'"
                >
                  Atrasados ({{ lateVehicles.length }})
                </li>
                <li
                  class="control"
                  data-mixitup-control
                  data-filter=".bloqueado"
                  :class="{
                    'mixitup-control-active': selectedMenu == 'devolvido',
                  }"
                  @click="selectedMenu = 'devolvido'"
                >
                  Devolvidos ({{ devolvedVehicles.length }})
                </li>
                <li
                  class="control"
                  data-mixitup-control
                  data-filter=".bloqueado"
                  :class="{
                    'mixitup-control-active': selectedMenu == 'bloqueado',
                  }"
                  @click="selectedMenu = 'bloqueado'"
                >
                  Bloqueados ({{ blockedVehicles.length }})
                </li>
                <li
                  class="control"
                  data-mixitup-control
                  data-filter=".preReserva"
                  :class="{
                    'mixitup-control-active': selectedMenu == 'preReserva',
                  }"
                  @click="selectedMenu = 'preReserva'"
                >
                  Pré-reservados ({{ preReserveVehicles.length }})
                </li>
              </ul>
            </div>

            <!-- Cada Veículo -->
            <div v-if="filteredVehicles.length > 0">
              <div class="row">
                <div
                  :key="v.id"
                  v-for="v in filteredVehicles"
                  class="mix col-xl-2 col-lg-3 col-md-4 col-sm-6"
                >
                  <div :class="v.dash_status">
                    <a @click="openModals(v.id, v.dash_status, v)">
                      <div class="card-car">
                        <div class="badge-car"></div>
                        <img class="img-car" :src="v.photo" width="230px" />
                        <div class="car-plate">
                          Veículo:
                          <span>{{ v.model }}</span>
                        </div>
                        <div class="car-plate">
                          Cor:
                          <span>{{ v.color }}</span>
                        </div>
                        <div class="car-plate">
                          Placa:
                          <span>{{ v.board }}</span>
                        </div>
                        <div class="car-plate">
                          Km:
                          <the-mask
                            disabled
                            class="km-in-home-card"
                            :value="v.current_km"
                            :mask="['####', '#.###', '##.###', '###.###']"
                          />
                          <!-- <span>{{ v.current_km }} km</span> -->
                        </div>
                        <div class="car-km">
                          {{
                            v.branch
                              ? v.branch.description
                              : "" | truncate(15, "...")
                          }}
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="count.loaded == '0'">
              <div class="fa-3x text-center">
                <i class="fas fa-circle-notch fa-spin"></i>
              </div>
            </div>
            <div v-else-if="filteredVehicles.length == 0" align="center">
              <div class="messageHome">
                Nenhum veículo disponível nessas condições.
              </div>
            </div>
            <!-- Cada Veículo -->

            <div class="row">
              <div class="col-12">
                <div class="legend-title">Legendas:</div>
                <div class="legend-info">
                  <span style="color: #8b00c7">Tarja Roxa:</span> Pré-reservado
                </div>
                <div class="legend-info">
                  <span class="black">Tarja Preta:</span> Devolvido e Bloqueado
                </div>
                <div class="legend-info">
                  <span class="red">Tarja Vermelha:</span> Atrasado
                </div>
                <div class="legend-info">
                  <span class="orange">Tarja Laranja:</span> Retirado
                </div>
                <div class="legend-info">
                  <span class="blue">Tarja Azul:</span> Reservado
                </div>
                <div class="legend-info">
                  <span class="green">Tarja Verde:</span> No Pátio
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <available-modal
      :modalStatus="modalAvailableStatus"
      :dataModal="dataModal"
      @changeModal="changeAvailableModal"
      @openModals="openModals"
      @OMDCk="openModalCheckin"
      v-if="loadModalPatio"
    ></available-modal>
    <locked-modal
      :modalStatus="modalLockedStatus"
      :dataModal="dataModal"
      @changeModal="changeLockedModal"
      @openModals="openModals"
      v-if="loadModalBloqueado"
    ></locked-modal>
    <reserved-modal
      :modalStatus="modalReservedStatus"
      :dataModal="dataModal"
      @changeModal="changeReservedModal"
      @openModals="openModals"
      @OMDCk="openModalCheckin"
      @OpenModalUser="openModalUser"
      v-if="loadModalReservado"
    ></reserved-modal>
    <retreat-modal
      :modalStatus="modalRetreatStatus"
      :dataModal="dataModal"
      @changeModal="changeRetreatModal"
      @openModals="openModals"
      @OMDCk="openModalCheckin"
      @OpenModalUser="openModalUser"
      v-if="loadModalRetirado"
    ></retreat-modal>
    <late-modal
      :modalStatus="modalLateStatus"
      :dataModal="dataModal"
      @changeModal="changeLateModal"
      @openModals="openModals"
      @OMDCk="openModalCheckin"
      @OpenModalUser="openModalUser"
      v-if="loadModalAtrasado"
    ></late-modal>
    <devoluted-modal
      :modalStatus="modalDevolutedStatus"
      :dataModal="dataModal"
      @changeModal="changeDevolutedModal"
      @openModals="openModals"
      @OMDCk="openModalCheckin"
      @OpenModalUser="openModalUser"
      @refresh="getCount"
      v-if="loadModalDevolvido"
    ></devoluted-modal>
    <checkin-modal
      :modalStatus="modalCheckinStatus"
      :dataModal="dataModalCheckin"
      @changeModal="changeCheckinModal"
      @openModals="openModals"
      @OpenModalUser="openModalUser"
      @OpenLightbox="openLightbox"
      v-if="loadModalCheckin"
    ></checkin-modal>
    <user-modal
      :modalStatus="modalUserStatus"
      :dataModal="dataModalUser"
      @changeModal="changeUserModal"
      @openModals="openModals"
      @OMDCk="openModalCheckin"
      v-if="loadModalUser"
    ></user-modal>

    <template>
      <vue-easy-lightbox
        :visible="visible"
        :imgs="imgs"
        @hide="handleHide"
      ></vue-easy-lightbox>
    </template>

    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
  </div>

  <!-- Home Page do Usuário Padrão -->

  <div v-else>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <div class="card-title">Meu Perfil</div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-10">
                <form action>
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="userName">Nome</label>
                        <input
                          type="text"
                          class="form-control"
                          id="userName"
                          placeholder
                          v-model="users.name"
                          disabled
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="userMail">E-mail</label>
                        <input
                          type="email"
                          class="form-control"
                          id="userMail"
                          placeholder
                          v-model="users.email"
                          disabled
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="userPhone">Celular</label>
                        <input
                          type="text"
                          class="form-control"
                          id="userPhone"
                          placeholder
                          v-model="users.cellphone"
                          disabled
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="userCNH">Número da CNH</label>
                        <input
                          type="text"
                          class="form-control"
                          id="userCNH"
                          placeholder
                          v-model="users.number_cnh"
                          disabled
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="userCateg">Categoria da CNH</label>
                        <v-select
                          :options="branches"
                          label="description"
                          :reduce="(branches) => branches.id"
                          class="style-chooser"
                          id="branches"
                          multiple
                          v-model="users.cat_cnh"
                          disabled
                        ></v-select>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="userDateTo">Data de Validade da CNH</label>
                        <input
                          type="date"
                          class="form-control"
                          id="userDateTo"
                          v-model="users.validity_cnh"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div class="col-md-2">
                <div class="user-img">
                  <img
                    class="user"
                    :src="users.photo"
                    width="100%"
                    height="198"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <div class="card-title">Minhas Últimas Viagens</div>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-hover table-sm">
                <thead>
                  <tr>
                    <th scope="col">Retirado em</th>
                    <th scope="col">Entregue em</th>
                    <th scope="col">Ações</th>
                  </tr>
                </thead>
                <tbody v-if="home_user.last_trips">
                  <tr
                    v-for="lastTrip in home_user.last_trips"
                    :key="lastTrip.id"
                  >
                    <td>
                      {{
                        lastTrip.checkout ? lastTrip.checkout.retreat_at : ""
                      }}
                    </td>
                    <td>
                      {{
                        lastTrip.checkin ? lastTrip.checkin.devoluted_at : ""
                      }}
                    </td>
                    <td>
                      <button
                        type="button"
                        class="btn btn-crud check"
                        @click="viewReserve(lastTrip.id)"
                        data-tooltip="tooltip"
                        data-dismiss="modal"
                        data-toggle="modal"
                        data-target="#modalLastTrips"
                        title="Check-Out"
                      >
                        <i class="fas fa-sign-out-alt"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="4" align="center">
                      Você ainda não realizou viagens.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <div class="card-title">Próximas Viagens</div>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-hover table-sm">
                <thead>
                  <tr>
                    <th scope="col">Data de Retirada</th>
                    <th scope="col">Data de Devolução</th>
                    <th scope="col">Veículo</th>
                    <th scope="col">Placa</th>
                  </tr>
                </thead>
                <tbody v-if="home_user.next_trips">
                  <tr
                    v-for="nextTrip in home_user.next_trips"
                    :key="nextTrip.id"
                  >
                    <td v-if="nextTrip.retreat_date">
                      {{ nextTrip.retreat_date }}
                    </td>
                    <td v-if="nextTrip.devolution_date">
                      {{ nextTrip.devolution_date }}
                    </td>
                    <td v-if="nextTrip.vehicles">
                      {{ nextTrip.vehicles.model }}
                    </td>
                    <td v-if="nextTrip.vehicles">
                      {{ nextTrip.vehicles.board }}
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="4" align="center">
                      Você não possui nenhuma reserva agendada.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import CtkDateTimePicker from "vue-ctk-date-time-picker";
import Multiselect from "vue-multiselect";
import AvailableModal from "./Modals/AvailableModal";
import ReservedModal from "./Modals/ReservedModal";
import RetreatModal from "./Modals/RetreatModal";
import LateModal from "./Modals/LateModal";
import DevolutedModal from "./Modals/DevolutedModal";
import CheckinModal from "./Modals/CheckinModal";
import UserModal from "./Modals/UserModal";
import LockedModal from "./Modals/LockedModal";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  data() {
    return {
      isLoading: true,
      fullPage: true,
      imgs: "", // Img Url , string or Array
      visible: false,
      index: 0, // default
      showLightbox: false,
      modalAvailableStatus: false,
      modalReservedStatus: false,
      modalRetreatStatus: false,
      modalLateStatus: false,
      modalDevolutedStatus: false,
      modalLockedStatus: false,
      modalUserStatus: false,
      dataModal: [],
      modalCheckinStatus: false,
      dataModalCheckin: {},
      loadModalReservado: false,
      loadModalRetirado: false,
      loadModalAtrasado: false,
      loadModalDevolvido: false,
      loadModalCheckin: false,
      loadModal: false,
      loadModalPatio: false,
      loadModalBloqueado: false,
      loadModalUser: false,
      imagesLightbox: [
        {
          path: "https://api.intermedica.innovareti.com.br//vehicle/image/53",
          caption: "Defafult",
        },
      ],
      users: [],
      selected: null,
      options: ["A", "B", "C", "D", "E"],
      index: 0,
      count: [],
      ciCount: "",
      vehiclesCount: [],
      selectedMenu: "todos",
      retreat_date: "",
      devolution_date: "",
      branches: [
        {
          id: null,
          description: "TODAS AS FILIAIS",
        },
      ],
      branchesAll: {
        id: null,
        description: "TODAS AS FILIAIS",
      },
      home: {
        branch_id: null,
      },
      checked: [],
      checklist_items: [{}],
      home_user: {
        last_trips: [
          {
            id: "",
          },
        ],
        next_trips: [
          {
            id: "",
          },
        ],
      },
      allVehicles: [],
      availableVehicles: [],
      reservedVehicles: [],
      retreatVehicles: [],
      devolvedVehicles: [],
      blockedVehicles: [],
      lateVehicles: [],
      preReserveVehicles: [],
      vehicles: [],
      dataVehicle: {},
    };
  },
  computed: {
    filteredVehicles: function () {
      switch (this.selectedMenu) {
        case "todos":
          return this.allVehicles;
        case "patio":
          return this.availableVehicles;
        case "reservado":
          return this.reservedVehicles;
        case "retirado":
          return this.retreatVehicles;
        case "patio":
          return this.availableVehicles;
        case "atrasado":
          return this.lateVehicles;
        case "devolvido":
          return this.devolvedVehicles;
        case "bloqueado":
          return this.blockedVehicles;
        case "preReserva":
          return this.preReserveVehicles;
      }
    },
  },
  methods: {
    openLightbox(data) {
      this.imgs = [
        data.photo1,
        data.photo2,
        data.photo3,
        data.photo4,
        data.photo5,
        data.photo6,
      ];
      this.index = 1; // index of imgList
      this.show();
    },

    show() {
      this.visible = true;
    },
    handleHide() {
      this.visible = false;
    },
    changeAvailableModal(status) {
      this.modalAvailableStatus = status;
    },
    changeReservedModal(status) {
      this.modalReservedStatus = status;
    },
    changeRetreatModal(status) {
      this.modalRetreatStatus = status;
    },
    changeLateModal(status) {
      this.modalLateStatus = status;
    },
    changeUserModal(status) {
      this.modalUserStatus = status;
    },
    changeLockedModal(status) {
      this.modalLockedStatus = status;
    },
    changeDevolutedModal(status) {
      this.modalDevolutedStatus = status;
    },
    changeCheckinModal(status) {
      this.modalCheckinStatus = status;
    },
    openModalCheckin(object) {
      this.modalCheckinStatus = true;
      this.dataModalCheckin = object;
      this.loadModalCheckin = true;
    },
    openModalUser(object) {
      this.modalUserStatus = true;
      this.dataModalUser = object;
      this.loadModalUser = true;
    },
    closeModals() {
      this.loadModalReservado = false;
      this.loadModalRetirado = false;
      this.loadModalAtrasado = false;
      this.loadModalDevolvido = false;
      this.loadModalCheckin = false;
      this.loadModalPatio = false;
      this.loadModalUser = false;
      this.loadModalBloqueado = false;
    },
    openModals(idVehicle, status, object, page) {
      if (typeof page === "undefined") {
        page = 1;
      }
      const self = this;
      const api = self.$store.state.api + "getInfoVehicle/?page=" + page;

      var data = {
        idVehicle: idVehicle,
        reserve_id: object.reserve_vehicle[0],
      };

      self.isLoading = true;
      self.$http
        .post(api, data)
        .then((response) => {
          self.dataVehicle = response.data;

          if (!page) {
            self.closeModals();
          }

          console.log(self.dataVehicle);

          self.dataVehicle.last_trips = self.dataVehicle.lastTrips.data;

          self.dataModal = self.dataVehicle;

          if (status == "patio") {
            self.modalAvailableStatus = true;
            self.loadModalPatio = true;
          } else if (status == "reservado") {
            self.modalReservedStatus = true;
            self.loadModalReservado = true;
          } else if (status == "retirado") {
            self.modalRetreatStatus = true;
            self.loadModalRetirado = true;
          } else if (status == "atrasado") {
            self.modalLateStatus = true;
            self.loadModalAtrasado = true;
          } else if (status == "devolvido") {
            self.modalDevolutedStatus = true;
            self.loadModalDevolvido = true;
          } else if (status == "bloqueado") {
            self.modalLockedStatus = true;
            self.loadModalBloqueado = true;
          }

          self.isLoading = false;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    changeImage(index) {
      //console.log(index);
    },
    backModalToModal() {
      let modal = document.getElementById("modalVisualizar");
      modal.modal(hidden);
    },

    filter() {
      const self = this;

      self.isLoading = true;

      self.count.loaded = 0;

      self.allVehicles = [];
      self.availableVehicles = [];
      self.reservedVehicles = [];
      self.retreatVehicles = [];
      self.devolvedVehicles = [];
      self.blockedVehicles = [];
      self.lateVehicles = [];
      self.preReserveVehicles = [];

      self.getCount();
      // self.getVehicles();
    },

    getCount: function () {
      const self = this;
      const api = self.$store.state.api + "homeCount/";

      let fd = new FormData();
      fd.append("branch_id", self.home.branch_id);

      self.$http
        .post(api, fd)
        .then((response) => {
          self.allVehicles = response.data.all;
          for (let i = 0; i < self.allVehicles.length; i++) {
            self.allVehicles[i].dash_status == undefined
              ? (self.allVehicles[i].dash_status = "reservado")
              : self.allVehicles[i].dash_status;
          }
          self.availableVehicles = response.data.available;
          self.reservedVehicles = response.data.reserved;
          for (let i = 0; i < self.reservedVehicles.length; i++) {
            self.reservedVehicles[i].dash_status = "reservado";
          }
          self.retreatVehicles = response.data.retreat;
          self.devolvedVehicles = response.data.devolved;
          self.blockedVehicles = response.data.blocked;
          self.lateVehicles = response.data.late;
          self.preReserveVehicles = response.data.preReserves;
          self.isLoading = false;
        })
        .then(() => {
          self.count.loaded = true;

          self.$forceUpdate();
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getBranches: function () {
      const self = this;
      const api = self.$store.state.api + "branches/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.branches = response.data.data;
          this.branches.unshift(this.branchesAll);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getChecklistItens: function () {
      const self = this;
      const api = self.$store.state.api + "checklistItems/";

      self.$http
        .get(api)
        .then((response) => {
          self.checklist_items = response.data.data;
          self.ciCount = response.data.count;

          for (let i = 0; i < self.ciCount; i++) {
            if (
              self.checklist_items[i].id == 1 ||
              self.checklist_items[i].id == 3
            ) {
              self.checked[i] = true;
            } else {
              self.checked[i] = false;
            }
          }
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getHomeUser: function () {
      const self = this;
      const api = self.$store.state.api + "homeUser/";

      self.$http
        .get(api)
        .then((response) => {
          self.home_user = response.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  components: {
    CtkDateTimePicker,
    vSelect,
    Multiselect,
    AvailableModal,
    ReservedModal,
    RetreatModal,
    LateModal,
    DevolutedModal,
    CheckinModal,
    UserModal,
    LockedModal,
    Loading,
  },
  mounted: function () {
    const self = this;
    self.getChecklistItens();
    self.getCount();
    // self.getVehicles();
    self.getBranches();
    /*
    if (this.user.access_nivel == 1) {
      self.getHomeUser();
    }
*/
    this.users = this.$store.state.user;
  },
};
</script>
<style scoped>
.max {
  width: 60%;
}
#photo {
  width: 300px;
  height: 150px;
}
.vue-lightbox-info h4[data-v-1884afde] {
  margin-top: -35px !important;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.km-in-home-card {
  outline: none;
  border: none;
  float: right;
  text-align: right;
  color: #5b5b5f;
  font-weight: 600;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue